import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Col, Row, Select, Spin } from 'antd';

import { mascaraCelularInteiro, formatarCpfCnpj } from '../../../helpers/utils';
import {
  getListaUsuario,
  getListaMatriz,
  getListaStatusSolicitacao,
  getListaStatusAtendimento,
} from '../../../services';

import IconeFiltrar from '../../../assets/icons/iconFiltrar.svg';
import * as S from './styles';

const { Option } = Select;

export const formatarDataFiltro = data => {
  if (!data) return null;

  if (typeof data.format === 'function') {
    return data.format('YYYY-MM-DD 00:00');
  }

  const dataMoment = moment(data);
  return dataMoment.isValid() ? dataMoment.format('YYYY-MM-DD 00:00') : null;
};

export function FormFiltros({
  isFiltroAtivo = () => {},
  paramsFilter = () => {},
  paginationFilter = () => {},
  handlerClear,
  loading = false,
}) {
  const [usuariosLista, setUsuariosLista] = useState([]);
  const [matrizLista, setMatrizLista] = useState([]);
  const [filtroAtivo, setFiltroAtivo] = useState(false);
  const [valueSolicitacao, setValueSolicitacao] = useState(null);
  const [valueDocMotorista, setValueDocMotorista] = useState(null);
  const [valueFoneMotorista, setValueFoneMotorista] = useState(null);
  const [valueDocProprietario, setValueDocProprietario] = useState(null);
  const [valueDate, setValueDate] = useState(null);
  const [valueUsuario, setValueUsuario] = useState(null);
  const [valueMatriz, setValueMatriz] = useState(null);

  const [valueStatusSolicitacao, setValueStatusSolicitacao] = useState(null);
  const [valueStatusAtendimento, setValueStatusAtendimento] = useState(null);

  const [statusSolicitacaoLista, setStatusSolicitacaoLista] = useState([]);
  const [statusAtendimentoLista, setStatusAtendimentoLista] = useState([]);

  const formatarFiltro = async () => {
    const arrayParamns = [
      {
        value: valueUsuario || null,
        name: 'IdUsuario',
      },
      {
        value: valueDate?.length ? formatarDataFiltro(valueDate[0]) : null,
        name: 'DataInicio',
      },
      {
        value: valueDate?.length ? formatarDataFiltro(valueDate[1]) : null,
        name: 'DataFim',
      },
      {
        value: valueDocMotorista || null,
        name: 'CPFMotorista',
      },
      {
        value: valueDocProprietario || null,
        name: 'DocumentoProprietario',
      },
      {
        value: valueSolicitacao || null,
        name: 'IdIntegracao',
      },
      {
        value: valueMatriz || null,
        name: 'IdMatriz',
      },
      {
        value: valueFoneMotorista || null,
        name: 'TelefoneMotorista',
      },
      {
        value: valueStatusSolicitacao || null,
        name: 'IdStatusSolicitacao',
      },
      {
        value: valueStatusAtendimento || null,
        name: 'IdStatusAtendimento',
      },
    ];

    const filterParamsDinamics = arrayParamns
      .filter(item => item.value)
      .map(item => `${item.name}=${item.value}&`)
      .join('')
      .slice(0, -1);

    return (
      paramsFilter(filterParamsDinamics),
      paginationFilter({ current: 1, pageSize: 15 })
    );
  };

  const listaUsuarios = async () => {
    const { data } = (await getListaUsuario()) || {};
    setUsuariosLista(Array.isArray(data?.items) ? data.items : []);
  };

  const listaMatriz = async () => {
    const response = await getListaMatriz();
    setMatrizLista(Array.isArray(response) ? response : []);
  };

  const listaStatusSolicitacao = async () => {
    const { data } = (await getListaStatusSolicitacao()) || {};
    setStatusSolicitacaoLista(Array.isArray(data) ? data : []);
  };

  const listaStatusAtendimento = async () => {
    const { data } = (await getListaStatusAtendimento()) || {};
    setStatusAtendimentoLista(Array.isArray(data) ? data : []);
  };

  const onChange = data => setValueDate(data ? [...data] : []);

  useEffect(() => {
    listaUsuarios();
    listaMatriz();
    listaStatusSolicitacao();
    listaStatusAtendimento();
  }, []);

  useEffect(() => {
    if (handlerClear) {
      setValueSolicitacao(null);
      setValueDocMotorista(null);
      setValueFoneMotorista(null);
      setValueDocProprietario(null);
      setValueDate([]);
      setValueUsuario(null);
      setValueMatriz(null);
      setValueStatusSolicitacao(null);
      setValueStatusAtendimento(null);
      paramsFilter(null);
    }
  }, [handlerClear, paramsFilter]);

  useEffect(() => {
    const isAtivo =
      !!valueSolicitacao?.length ||
      !!valueDocMotorista?.length ||
      !!valueFoneMotorista?.length ||
      !!valueDocProprietario?.length ||
      !!valueDate?.length ||
      !!valueMatriz ||
      !!valueUsuario ||
      !!valueStatusSolicitacao ||
      !!valueStatusAtendimento;
    setFiltroAtivo(isAtivo);
    isFiltroAtivo(isAtivo);
  }, [
    valueSolicitacao,
    valueDocMotorista,
    valueFoneMotorista,
    valueDocProprietario,
    valueUsuario,
    valueStatusSolicitacao,
    valueStatusAtendimento,
    isFiltroAtivo,
    valueMatriz,
    valueDate,
  ]);

  return (
    <Spin spinning={loading} size="large">
      <Row style={{ padding: 0 }} gutter={16} id="filterForm">
        <Col className="gutter-row" span={8} style={{ padding: 0 }}>
          <S.BoxInput>
            <S.LabelInput>Solicitação</S.LabelInput>
            <S.InputItem
              id="inputSolicitacao"
              placeholder="Digite o número da solicitação"
              value={valueSolicitacao}
              onChange={e => setValueSolicitacao(e.target.value)}
              allowClear
            />
          </S.BoxInput>
        </Col>
        <Col className="gutter-row" span={8} style={{ padding: 0 }}>
          <S.BoxInput>
            <S.LabelInput>CPF do Motorista</S.LabelInput>
            <S.InputItem
              placeholder="Digite o número do documento do motorista"
              value={formatarCpfCnpj(valueDocMotorista)}
              onChange={e => setValueDocMotorista(e.target.value)}
              maxLength="14"
              allowClear
            />
          </S.BoxInput>
        </Col>
        <Col className="gutter-row" span={8} style={{ padding: 0 }}>
          <S.BoxInput>
            <S.LabelInput>CNPJ/CPF do Proprietário</S.LabelInput>
            <S.InputItem
              placeholder="Digite o número do documento do proprietário"
              value={formatarCpfCnpj(valueDocProprietario)}
              onChange={e => setValueDocProprietario(e.target.value)}
              allowClear
            />
          </S.BoxInput>
        </Col>
      </Row>
      <Row style={{ padding: 0, marginTop: 25 }} gutter={16}>
        <Col className="gutter-row" span={8} style={{ padding: 0 }}>
          <S.BoxInput>
            <S.LabelInput>Data de Inclusão</S.LabelInput>
            <S.DateFilter
              format="DD/MM/YYYY"
              onChange={onChange}
              value={valueDate}
              allowClear={false}
            />
          </S.BoxInput>
        </Col>
        <Col className="gutter-row" span={8} style={{ padding: 0 }}>
          <S.BoxInput>
            <S.LabelInput>Matriz de Consulta</S.LabelInput>
            <S.SelectItem
              allowClear
              placeholder="Escolha a matriz de consulta"
              value={valueMatriz}
              showSearch
              optionFilterProp="children"
              onChange={value => setValueMatriz(value)}
            >
              {matrizLista?.map((matriz, index) => (
                <Option key={index} value={matriz?.id || ''}>
                  {matriz?.nome || ''}
                </Option>
              ))}
            </S.SelectItem>
          </S.BoxInput>
        </Col>
        <Col className="gutter-row" span={8} style={{ padding: 0 }}>
          <S.BoxInput>
            <S.LabelInput>Usuário</S.LabelInput>
            <S.SelectItem
              aria-label="lista-usuario"
              allowClear
              showSearch
              optionFilterProp="children"
              placeholder="Escolha um o usuário"
              value={valueUsuario}
              onChange={value => setValueUsuario(value)}
            >
              {usuariosLista?.map((user, index) => (
                <Option key={index} value={user?.id || ''}>
                  {user?.nome}
                </Option>
              ))}
            </S.SelectItem>
          </S.BoxInput>
        </Col>
      </Row>
      <Row style={{ padding: 0, marginTop: 28 }} gutter={16}>
        <Col className="gutter-row" span={8} style={{ padding: 0 }}>
          <S.BoxInput>
            <S.LabelInput>Telefone do Motorista</S.LabelInput>
            <S.InputItem
              placeholder="Digite o número do telefone do motorista"
              value={mascaraCelularInteiro(valueFoneMotorista)}
              onChange={e =>
                setValueFoneMotorista(mascaraCelularInteiro(e.target.value))
              }
              maxLength="15"
              allowClear
            />
          </S.BoxInput>
        </Col>
        <Col className="gutter-row" span={8} style={{ padding: 0 }}>
          <S.BoxInput>
            <S.LabelInput>Status de Solicitação</S.LabelInput>
            <S.SelectItem
              aria-label="lista-status-solicitacao"
              allowClear
              showSearch
              optionFilterProp="children"
              placeholder="Escolha um status"
              value={valueStatusSolicitacao}
              onChange={value => setValueStatusSolicitacao(value)}
            >
              {statusSolicitacaoLista?.map((solicitacao, index) => (
                <Option key={index} value={solicitacao?.id || ''}>
                  {solicitacao?.descricao}
                </Option>
              ))}
            </S.SelectItem>
          </S.BoxInput>
        </Col>
        <Col className="gutter-row" span={8} style={{ padding: 0 }}>
          <S.BoxInput>
            <S.LabelInput>Status de Atendimento</S.LabelInput>
            <S.SelectItem
              aria-label="lista-status-atendimento"
              allowClear
              showSearch
              optionFilterProp="children"
              placeholder="Escolha um status"
              value={valueStatusAtendimento}
              onChange={value => setValueStatusAtendimento(value)}
            >
              {statusAtendimentoLista?.map((atendimento, index) => (
                <Option key={index} value={atendimento?.id || ''}>
                  {atendimento?.descricao}
                </Option>
              ))}
            </S.SelectItem>
          </S.BoxInput>
        </Col>
      </Row>
      <Row style={{ padding: 0, marginTop: 28 }} gutter={16}>
        <Col className="gutter-row" span={8} style={{ padding: 0 }}>
          <S.BtnFiltrar
            aria-label="botao-filtrar"
            onClick={formatarFiltro}
            disabled={!filtroAtivo}
          >
            <img src={IconeFiltrar} alt="filtrar" />
            Filtrar
          </S.BtnFiltrar>
        </Col>
      </Row>
    </Spin>
  );
}
